<div [style.display]="isVisible() ? 'flex' : 'none'" class="photo-wrapper" [id]="htmlId()">
  @if (isCommentPhotoItem()) {
    <div [id]="'user_' + htmlId()">[{{ userNameTrimmed() }}]</div>
  }

  @if (isDesktopDevice()) {
    @if (showPhotoMenu()) {
      <div class="menu-backdrop" (click)="showPhotoMenu.set(false)"></div>
    }
    <div class="photo-menu-container">
      <button
        type="button"
        role="button"
        class="photo-opener"
        (click)="onPhotoMenuClick($event)"
        [disabled]="formControl?.disabled">
        <div class="icon-safe-zone">
          <mat-icon class="icon">photo_camera</mat-icon>
        </div>
        <span>{{ properties.text }}</span>
        <mat-icon class="dropdown-icon">{{ showPhotoMenu() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      @if (showPhotoMenu()) {
        <div class="photo-menu">
          <button type="button" class="menu-item" (click)="onCaptureClick($event)">
            <mat-icon>videocam</mat-icon>
            <span>{{ translateService.instant('liveforms-editor.photo-item.menu.capture') }}</span>
          </button>
          <button type="button" class="menu-item" (click)="onSelectFileClick($event)">
            <mat-icon>folder_open</mat-icon>
            <span>{{ translateService.instant('liveforms-editor.photo-item.menu.select-file') }}</span>
          </button>
        </div>
      }
    </div>
  } @else {
    <button
      type="button"
      role="button"
      class="photo-opener"
      [disabled]="formControl?.disabled"
      (click)="onPhotoOpenClick($event)">
      <div class="icon-safe-zone">
        <mat-icon class="icon">photo_camera</mat-icon>
      </div>
      <span>{{ properties.text }}</span>
    </button>
  }

  <input #fileInput type="file" (change)="onFileChange($event)" class="file-input" />

  @if (!isGalleryFirstLoaded()) {
    <div class="photo-gallery" draggable="false">
      @for (item of Array(itemsLoadingCount()); track $index) {
        <div [ngClass]="{ 'photo-skeleton': !isLoaded(item) && !isErrored(item) }"></div>
      }
    </div>
  } @else {
    <div class="photo-gallery" draggable="false">
      @for (item of displayGalleryItems(); track item.resourceData.fileId) {
        <div
          [ngClass]="{
            'photo-skeleton': !isLoaded(item) && !isErrored(item),
            'photo-errored': isErrored(item)
          }">
          @if (isErrored(item)) {
            <mat-icon size="6">broken_image</mat-icon>
            <div>
              {{
                translateService.instant('liveforms-editor.photo-item.image.error', {
                  filename: item.resourceData.fileId
                })
              }}
            </div>
          } @else {
            <img
              class="photo-item"
              [ngClass]="{
                'photo-item-loaded': isLoaded(item),
                'photo-item-loading': !isLoaded(item) && !isErrored(item)
              }"
              [id]="'photo_' + item.resourceData.fileId"
              [src]="item.src || ''"
              [alt]="item.resourceData.fileId"
              draggable="false"
              (load)="setItemAsLoaded(item)"
              (error)="setItemAsErrored(item)"
              (click)="onThumbnailClick($event, item)" />
          }
        </div>
      }
    </div>
  }

  @if (uploadErrorMessage()) {
    <div class="dialog-overlay" (click)="uploadErrorMessage.set(null)">
      <div class="dialog-content load-error-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>{{ translateService.instant('liveforms-editor.photo-item.error.header') }}</h3>
          <button class="close-button" (click)="uploadErrorMessage.set(null)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="load-error-container">
          <div class="error-message">
            <mat-icon>error</mat-icon>
            <p>{{ uploadErrorMessage() }}</p>
          </div>
        </div>
      </div>
    </div>
  }

  @if (previewItem()) {
    <div class="dialog-overlay" (click)="closePreview()">
      <div class="dialog-content" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3 [ngClass]="['preserve-newlines']">{{ properties.text }}</h3>
          <button class="close-button" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="dialog-image-input-wrapper">
          <img [src]="previewItem()?.src" [alt]="previewItem()?.resourceData?.fileId || ''" draggable="false" />
          <div class="image-overlay" draggable="false"></div>
          @if (formControl?.enabled) {
            <button type="button" role="button" class="control" (click)="onDeletePhotoClick()">
              <div class="inline-action-icon">
                <mat-icon>delete</mat-icon>
              </div>
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (showWebcamDialog()) {
    <div class="dialog-overlay" (click)="closeWebcamDialog()">
      <div class="dialog-content webcam-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>{{ translateService.instant('liveforms-editor.photo-item.webcam.title') }}</h3>
          <button class="close-button" (click)="closeWebcamDialog()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="webcam-container">
          @if (webcamErrorMessage()) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              <p>{{ webcamErrorMessage() }}</p>
            </div>
          } @else {
            @if (showWebcam()) {
              <webcam
                [trigger]="webcamTriggerObservable"
                (imageCapture)="handleWebcamImage($event)"
                (initError)="handleWebcamInitError($event)"
                [imageQuality]="0.92"
                [width]="640"
                [height]="480"></webcam>
            } @else if (capturedWebcamImage()) {
              <img [src]="capturedWebcamImage()!.imageAsDataUrl" alt="Captured photo" />
            }
          }
        </div>

        <div class="dialog-actions">
          @if (showWebcam() && !webcamErrorMessage()) {
            <button type="button" class="btn-primary" (click)="triggerWebcamCapture()">
              <mat-icon>photo_camera</mat-icon>
              {{ translateService.instant('liveforms-editor.photo-item.webcam.capture') }}
            </button>
          }

          @if (capturedWebcamImage()) {
            <button type="button" class="btn-secondary" (click)="retakeWebcamPhoto()">
              <mat-icon>refresh</mat-icon>
              {{ translateService.instant('liveforms-editor.photo-item.webcam.retake') }}
            </button>
            <button type="button" class="btn-primary" (click)="confirmWebcamPhoto()">
              <mat-icon>check</mat-icon>
              {{ translateService.instant('liveforms-editor.photo-item.webcam.use-photo') }}
            </button>
          }

          <button type="button" class="btn-secondary" (click)="closeWebcamDialog()">
            {{ translateService.instant('liveforms-editor.photo-item.webcam.cancel') }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
